import React from "react";
import SettingsSection from "../SettingsSection";

export default function RolePanelsSection({
  channels,
  rolePanels,
  setRolePanels,
}) {
  const channelName = (id) =>
    channels.find((c) => c.id === id)?.name || "unknown";

  const removePanel = (panelId) => {
    setRolePanels(rolePanels.filter((p) => p.panelId !== panelId));
  };

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        View and remove existing self-role panels. Create new panels with full
        preview and formatting via <code>/setup-roles</code> in Discord.
      </p>

      {rolePanels.length > 0 ? (
        <div className="settings-item-list">
          {rolePanels.map((panel) => (
            <div key={panel.panelId} className="settings-item-row">
              <div className="settings-item-info">
                <strong>{panel.title || "Role Panel"}</strong>
                <br />
                <span className="settings-item-meta">
                  #{channelName(panel.channelId)} · {panel.roles?.length || 0}{" "}
                  roles · {panel.picker || "menu"} · {panel.mode || "multi"}
                </span>
                {panel.message && (
                  <p className="settings-item-snippet">
                    {panel.message.slice(0, 120)}
                    {panel.message.length > 120 ? "…" : ""}
                  </p>
                )}
              </div>
              <button
                type="button"
                className="manage-btn settings-item-action"
                onClick={() => removePanel(panel.panelId)}
              >
                REMOVE
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="help-text">
          No role panels configured yet.
        </p>
      )}
    </SettingsSection>
  );
}
